module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAD1BMVEUAW7rawxsAW7t/mF7/1QCzxg4pAAAAAnRSTlPU+CChtw0AAAAxSURBVEjH7csxEQAgDASwt4AFLNQC/jUhofd7sifp3ZqiKIqi7GVqeTVFURRF2cupfb6QiufYvy3hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ua.png
// module id = Y1rk
// module chunks = 0